import _ from 'underscore';

const newTagForAdScheduleTimezoneSettings = [
];

export const selectors = _.flatten([
  newTagForAdScheduleTimezoneSettings,
]);
